import { LanguageCode } from '../Models/Models';

const slovakNames = typeof Intl !== 'undefined' && 'DisplayNames' in Intl
    ? new Intl.DisplayNames(['sk'], { type: 'language' })
    : null;

/** Slovak display name of a language ("nemčina"), falling back to the upper-cased code. */
export function languageName(code: LanguageCode): string {
    try {
        const name = slovakNames?.of(code);
        if (name && name !== code) return name;
    } catch {
        // invalid code for Intl - fall through
    }
    return code.toUpperCase();
}

/** The language's name in itself ("Deutsch"), used to make the catalog search match native names too. */
export function nativeLanguageName(code: LanguageCode): string {
    try {
        return new Intl.DisplayNames([code], { type: 'language' }).of(code) ?? code;
    } catch {
        return code;
    }
}
